import './App.css';

/**
 * Renders a list of differentials based on the current question.
 * 
 * @param {Object} props - The component props.
 * @param {Array} props.currentQuestion - An array of differential objects representing the current question.
 * @returns {JSX.Element} A JSX element containing a list of rendered differentials.
 */
function Differentials(props) {
  let listDifferentials;
  let hoursPerWeek = '';

  if(props.jobTitle === 'adult-education-teacher'){
    hoursPerWeek = props.hoursPerWeek
  }

  // Render differentials based on the current differential
  const differentials = props.currentQuestion;
  if(differentials && Array.isArray(differentials)){
    listDifferentials = differentials.map((differential, index) =>
        <tr key={`differential-${index}`} className={differential.qualify == false ? 'differential not-qualify' : 'differential'}>
            <td><p className='content'>{differential.title}{hoursPerWeek}</p></td>
            <td><p className='content small'>{differential.content}</p><p className='content small nickname'>{differential.nickname}</p></td>
            <td><p className='content'><strong>{differential.dollarSign}</strong></p></td>
        </tr>
    );
  }

  return (
    <>
      <table className="differentials">
        <tbody>
          {listDifferentials}
        </tbody>
      </table>
    </>
  );
}

export default Differentials;